import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/firebase";

const buildMenuDocId = (userId) => `${userId}-menus`;

/**
 * Récupère le menu hebdo sauvegardé d'un utilisateur.
 * Stockage: collection "Menus", doc "${userId}-menus"
 * Retourne { weeklyMenu, savedAt, updatedAt } ou null.
 */
export async function getUserWeeklyMenu(userId) {
  if (!userId) return null;
  const docRef = doc(db, "Menus", buildMenuDocId(userId));
  try {
    const snap = await getDoc(docRef);
    if (!snap.exists()) return null;
    const data = snap.data() || {};
    if (!data.weeklyMenu) return null;
    return {
      weeklyMenu: data.weeklyMenu,
      savedAt: data.savedAt || null,
      updatedAt: data.updatedAt || null,
      diverse: typeof data.diverse === "boolean" ? data.diverse : null,
      sameLunchDinnerDays: Array.isArray(data.sameLunchDinnerDays) ? data.sameLunchDinnerDays : [],
    };
  } catch (e) {
    console.error("Erreur getUserWeeklyMenu:", e);
    throw e;
  }
}

/**
 * Sauvegarde (ou remplace) le menu hebdo d'un utilisateur.
 */
export async function saveUserWeeklyMenu(userId, weeklyMenu, meta = {}) {
  if (!userId) throw new Error("userId manquant");
  if (!weeklyMenu) throw new Error("weeklyMenu manquant");
  const docRef = doc(db, "Menus", buildMenuDocId(userId));
  const now = Date.now();
  const payload = {
    weeklyMenu,
    savedAt: now,
    updatedAt: now,
    ...meta,
  };
  try {
    await setDoc(docRef, payload, { merge: true });
    return { savedAt: now };
  } catch (e) {
    console.error("Erreur saveUserWeeklyMenu:", e);
    throw e;
  }
}
